import React from 'react';
import { useNavigate } from 'react-router-dom';
//import { logout } from '../../firestore/firestore';
import closeIcon from 'icons/close-48-white.png';
import AppVersion from '../common/AppVersion';
import { getCurrentUser, getCurrentUserEmail, getTestMode } from 'store/storeValtio';
import { adjustDemoData } from 'components/settings/loadData';

export default function Menu({openMenu, onClose}) {
    const navigate = useNavigate();
    const testMode = getTestMode();
    //if (testMode) console.log('Menu test mode', testMode);

    function close() {
      //console.log('close');
      onClose();
    }

    function clicked(target) {
      //console.log('SB clicked', target);
      onClose();
      navigate(target);
    }

    function adjust(t) {
      console.log('adjust', t);
      if (getCurrentUserEmail() !== 'demo@demodata.com') return;
      adjustDemoData();
    }

    return (
    <div>
      <div className={`transition ease-in-out duration-300 top-0 right-0 w-[70vw] h-[92%] bg-blue-600 pl-4 text-white fixed z-40 
        ${openMenu ? 'translate-x-0 ' : 'translate-x-full'}`}>
        <div className={'pt-8 small:pt-12 '} onClick={() => close()}>
          <img className={ 'h-8 w-8 small:h-12 small:w-12 hover:cursor-pointer'} src={closeIcon} alt='' />
        </div>

        <AppVersion />

        <div className={'mt-8 small:mt-12 ml-2'} >
            <MenuItem title={'Profile'} target={'/profile'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Add Medication'} target={'/create'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Change/Add User'} target={'/changeUser'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Delete User'} target={'/deleteUser'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Export Data'} target={'/export'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Sort Order'} target={'/sortOrder'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Registration'} target={'/registration'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Clear Data'} target={'/clear'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Cleanup'} target={'/cleanup'} doClick={(t)=>clicked(t)} />
            <MenuItem title={'Adjust Demo Data'} target={null} doClick={(t)=>adjust(t)} />
            {testMode &&
              <>
              <MenuItem title={'Development'} target={'/dev'} doClick={(t)=>clicked(t)} />
              <MenuItem title={'Notifications'} target={'/notifications'} doClick={(t)=>clicked(t)} />
              <MenuItem title={'Sync Data'} target={'/sync'} doClick={(t)=>clicked(t)} />
              </>
            }
        </div>
      </div>
    </div>
    );
  }

  function MenuItem({title,target,doClick}) {

    function clicked() {
      //console.log('MI clicked', target);
      doClick(target);
    }

    return (
        <div 
        onClick={clicked}
        className={'text-lg small:text-xl py-1 small:py-2 font-semibold hover:font-bold hover:cursor-pointer '} 
        >
            {title}
        </div>
    );

  }